import React, { useCallback, useMemo } from 'react';
import type { MenuProps } from 'antd';
import { Dropdown, Button } from 'antd';
import type { DynamicComponentProps } from '@/types/commontypes';

const widthList = Array.from({ length: 5 }, (_, i) => i + 1);

// tslint: disable - next - line: variable - name
const LineWidthDashOptionPicker: React.FC<DynamicComponentProps<number>> = ({ value, onChange }) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      onChange?.(Number(e.currentTarget.dataset.value));
    },
    [onChange],
  );

  const items: MenuProps['items'] = useMemo(
    () =>
      widthList.map(wid => ({
        key: wid,
        label: (
          <a onClick={handleClick} data-value={wid} style={{ marginLeft: '5px' }}>
            <LineWidth width={wid} />
          </a>
        ),
      })),
    [handleClick],
  );

  return (
    <Dropdown menu={{ items }} trigger={['click']} className="border p-2">
      <Button title="xyz">
        <LineWidth width={value} />
      </Button>
    </Dropdown>
  );
};

const LineWidth = ({ width }: { width: number }) => {
  return (
    <div
      style={{
        borderTop: `${width}px solid #000`,
        width: '24px',
        backgroundColor: 'transparent',
        margin: '5px 0',
      }}
    />
  );
};

export default LineWidthDashOptionPicker;
